import { IReportService } from "../../service/report/ReportService";

export default class GetApplicantsInteractor {
  private reportService: IReportService;

  constructor(reportService) {
    this.reportService = reportService;
  }

  async execute(fullName: string) {
    return this.reportService.getApplicantList(fullName);
  }
}
